// @flow

import formatPrice from './formatPrice';
import formatPriceWithCurrencySymbol from './formatPriceWithCurrencySymbol';

import type { Currency } from '@zapier/common-utils';

import type { PriceFormattingOptions } from '@zapier/design-system-revenue/src/types';

/**
 * Applies currency multiplier and formats price
 */
export default (
  price: number,
  currency: Currency = {
    multiplier: 1,
    name: 'USD',
    symbol: '$',
  },
  includeSymbol: boolean = true,
  formattingOptions: PriceFormattingOptions
): string => {
  const adjusted = price * currency.multiplier;
  return includeSymbol
    ? formatPriceWithCurrencySymbol(
        adjusted,
        formattingOptions,
        currency.symbol
      )
    : formatPrice(adjusted, formattingOptions);
};
